<template>
  <div>
    <v-stepper flat class="borderless shadowless" value="4">
      <v-stepper-header flat class="borderless shadowless">
        <v-stepper-step step="1" complete>Détails préliminaires</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="2" complete>Ajouter les responsables</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="3" complete>Ajouter les participants</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="4">Notification de rappel</v-stepper-step>
      </v-stepper-header>
    </v-stepper>
    <br />

    <v-snackbar
      v-model="snackbar"
      :timeout="snackbar_timeout"
      :color="snackbar_color"
      :top="true"
    >{{ snackbar_message }}</v-snackbar>

    <v-card class="mb-3">
      <v-card-title>
        <h6 class="primary--text">Programmer le moment d'envoi de la notification de rappel</h6>
      </v-card-title>

      <v-card-text>
        <v-form @submit.prevent>
          <v-container fluid grid-list-md>
            <v-layout row wrap align-center>
              <v-flex xs5>
                <v-menu v-model="menu1" :close-on-content-click="false" max-width="290">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="sendingDateMoment"
                      clearable
                      label="Date d'envoi"
                      readonly
                      v-on="on"
                      prepend-icon="mdi-calendar"
                      solo
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="sending_date" :min="allowedDate" @input="menu1 = false"></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs5 offset-xs1>
                <v-menu
                  ref="menu"
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="time"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="time"
                      label="Heure d'envoi"
                      prepend-icon="mdi-timetable"
                      v-on="on"
                      solo
                      clearable
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="menu2"
                    v-model="time"
                    format="24hr"
                    @click:minute="$refs.menu.save(time)"
                    solo
                  ></v-time-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>

    <v-expansion-panels v-model="panel" multiple>
      <v-expansion-panel v-for="(item, index) in liste_lang.length" :key="index">
        <v-expansion-panel-header>
          <div class="text-left">
            GROUPE DE LA LANGUE |
            <strong>{{ liste_lang[index] }}</strong> |
            <span class="ml-1">
              <strong>{{ groupe_lang[liste_lang[index]].length }}</strong> personnes
            </span>
          </div>

          <div class="text-right">
            <v-btn-toggle v-model="toggle_multiple[index]" multiple>
              <v-btn v-model="btn_audio[index]" dark color="primary">
                <v-icon color="white">mdi-microphone-outline</v-icon>
                <span>Audio</span>
              </v-btn>
              <v-btn v-model="btn_sms[index]" dark color="light-blue">
                <v-icon color="white">mdi-chat-processing</v-icon>
                <span>Message SMS</span>
              </v-btn>
            </v-btn-toggle>
          </div>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <form @submit.prevent="newEvent4" enctype="multipart/form-data">
            <div v-if="btn_audio[index]==true">
              <label>Importer le message vocal</label>
              <v-btn color="primary" solo class="mb-3">
                <input
                  type="file"
                  @change="onImageChange"
                  accept=".wav"
                  hint="Importer le message vocal"
                />
              </v-btn>

              <v-textarea
                v-model="audio_msg[index]"
                label="Envoyer un SMS en cas d'échec de réception du message vocal"
                solo
              ></v-textarea>
            </div>

            <div v-if="btn_sms[index]==true">
              <v-textarea v-model="sms_msg[index]" label="Ecrire un SMS à envoyer" solo></v-textarea>
            </div>

            <div v-else></div>
          </form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <div class="text-center mt-5">
      <v-btn
        rounded
        color="info"
        @click="previousStep()"
        class="mx-3"
        :disabled="loadingSave"
      >Précédent</v-btn>
      <v-btn
        rounded
        color="primary"
        :loading="loadingSave"
        :disabled="loadingSave"
        @click="newEvent4()"
      >Terminer</v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "create-event-4",

  data: () => ({
    panel: [0, 1, 2, 3],
    languages: [],
    groupe_lang: [],
    toggle_multiple: [],
    audio_msg: [],
    sms_msg: [],
    file_uploaded: [],
    btn_audio: [],
    btn_sms: [],
    audio_path: [],
    notification: {},
    current_index: null,
    snackbar: false,
    snackbar_message: "",
    snackbar_timeout: 5000,
    snackbar_color: "",

    loadingSave: false,
    multiplePanel: true,

    sending_date: null,
    menu1: false,
    menu2: false,
    time: null
  }),

  computed: {
    liste_lang() {
      let acteurs = this.$store.getters.getActorsNewEvent;

      let groupe = acteurs.reduce((h, { id, contact, language }) => {
        return Object.assign(h, {
          [language]: (h[language] || []).concat({ id, contact })
        });
      }, {});
      this.languages = Object.getOwnPropertyNames(groupe);
      this.taille_languages = this.languages.length;

      this.groupe_lang = groupe;

      return this.languages;
    },

    sendingDateMoment() {
      return this.sending_date
        ? this.$moment(this.sending_date).format("D MMMM YYYY")
        : "";
    },

    allowedDate() {
      let aujourdhui = this.$moment(new Date()).format("YYYY-MM-DD");
      return aujourdhui;
    }

    /*allowedHour(){
      let heure = this.$moment(new Date()).format('hh:mm');
      return heure;
    }*/
  },

  methods: {
    previousStep() {
      this.$router.push({ name: "events.new-3" /*, params: { Pid: value }*/ });
    },

    onImageChange(e) {
      var position = this.current_index;
      let clesCreuses = Object.keys(this.btn_audio);
      for (let i = 0; i < clesCreuses.length; i++) {
        if (position != clesCreuses[i]) {
          position = clesCreuses[i];
          break;
        }
      }
      this.current_index = position;
      this.audio_path[position] = e.target.files[0];
    },

    async newEvent4() {
      this.loadingSave = true;
      // Save event first
      await this.$store.dispatch("createEvent");
      const data = this.$store.getters.getEvent;
      if (data) {
        this.loadingSave = false;
        setTimeout(
          this.$router.push({
            name: "events.coming",
            params: { new_event_added: true }
          }),
          2000
        );
        for (let i = 0; i < this.liste_lang.length; i++) {
          await this.saveNotificationFile(this.audio_path[i], data.id);
          let langue = this.liste_lang[i];
          const liste = this.groupe_lang[langue];
          let contacts = "";

          liste.forEach(function(item) {
            contacts = item.contact + "," + contacts;
          });

          if (langue == null || langue == undefined) {
            langue = "Français";
          }
          this.notification.language = langue;
          this.notification.audio_msg = this.audio_msg[i];
          this.notification.sms = this.sms_msg[i];
          this.notification.actor_contacts = contacts;
          this.notification.sending_date = this.sending_date;
          this.notification.sending_hour = this.time;
          this.notification.event_id = data.id;
          await this.saveNotifications(this.notification);
        }
      } else {
        console.log("Something went wrong!");
      }
    },

    async saveNotificationFile(file, id) {
      if (file != null) {
        const config = { headers: { "content-type": "multipart/form-data" } };
        let formData = new FormData();
        formData.append("audio_path", file);
        formData.append("event_id", id);
        try {
          await axios
            .post("/api/upload-file", formData, config)
            .then(response => {
              this.notification.audio_path = response.data;
            });
        } catch (error) {
          console.log(error);
        }
      }
    },
    async saveNotifications(notification) {
      try {
        await axios.post("/api/notification_messages", notification);
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style scoped>
.theme--light.v-subheader {
  font-size: 1.3em;
  color: black;
}
</style>




// WEBPACK FOOTER //
// resources/assets/js/pages/events/create-4.vue